var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13V14C13.5523 14 14 13.5523 14 13H13ZM19 13H18C18 13.5523 18.4477 14 19 14V13ZM19 19V18C18.4477 18 18 18.4477 18 19H19ZM13 19H14C14 18.4477 13.5523 18 13 18V19ZM14 28V19H12V28H14ZM18 19V28H20V19H18ZM28 18H19V20H28V18ZM19 14H28V12H19V14ZM18 4V13H20V4H18ZM14 13V4H12V13H14ZM4 14H13V12H4V14ZM13 18H4V20H13V18Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenExit);
export default __webpack_public_path__ + "static/media/fullscreen-exit.c75c543cd8a89518741877e4a3cf57c6.svg";
export { ForwardRef as ReactComponent };